module.exports = __webpack_public_path__ + "static/img/logo05.84db649.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo05.png
// module id = Wa3e
// module chunks = 1